import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { CircleSolidGlyph } from '@acast-tech/decibel-glyphs';
import T from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { useId } from '../../hooks/useId';
import { Input, Label, LabelDescription, LabelWrapper, overlayStyles, StyledIcon, ToggleElement, ToggleWrapper } from '../../styles/toggles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Overlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "Overlay",
  componentId: "sc-1xrvfk5-0"
})(["", ";border-radius:50%;"], overlayStyles);
const Radio = /*#__PURE__*/forwardRef(function Radio(_ref, forwardedRef) {
  let {
    id,
    label,
    description,
    invalid = false,
    disabled = false,
    required = false,
    highlighted = false
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["id", "label", "description", "invalid", "disabled", "required", "highlighted"]);

  const guid = useId('radio');
  const radioId = id || guid;
  const descriptionId = `${radioId}-description`;
  return /*#__PURE__*/_jsxs(ToggleWrapper, {
    children: [/*#__PURE__*/_jsxs(ToggleElement, {
      children: [/*#__PURE__*/_jsx(Input, Object.assign({}, restProps, {
        ref: forwardedRef,
        id: radioId,
        type: "radio",
        disabled: disabled,
        required: required,
        "aria-invalid": invalid || undefined,
        "aria-describedby": description ? descriptionId : undefined
      })), /*#__PURE__*/_jsx(Overlay, {
        highlighted: highlighted,
        children: /*#__PURE__*/_jsx(StyledIcon, {
          glyph: CircleSolidGlyph,
          size: "6px"
        })
      })]
    }), label && /*#__PURE__*/_jsxs(LabelWrapper, {
      children: [/*#__PURE__*/_jsx(Label, {
        htmlFor: radioId,
        disabled: disabled,
        children: label
      }), description && /*#__PURE__*/_jsx(LabelDescription, {
        id: descriptionId,
        disabled: disabled,
        children: description
      })]
    })]
  });
});
Radio.propTypes = {
  id: T.string,
  label: T.node,
  description: T.node,
  disabled: T.bool,
  invalid: T.bool,
  required: T.bool,
  highlighted: T.bool
};
export { Radio };